<template>
  <div class="go-in">
    <banner title="走进佳渝" />
    <div class="section">
      <div class="section-content">
        <div class="content-summary">
          <div class="summary-left">
            <p class="title">公司简介</p>
            <p class="eTitle">ABOUT US</p>
            <p class="content">
              重庆佳渝测绘有限公司创立于2008年，是一家具有独立法人资格的企业。统一信用代码：91500106671016695P。公司业务范围:测绘航空摄影;摄影测量与遥感;工程测量；不动产测量；地理信息系统工程；土地规划；房地产项目手续代理等。致力于空间地理信息应用价值的提升。公司现拥有重庆市规划和自然资源局颁发的乙级测绘资质（乙测资质5010735），2020年被授予“重庆市高新技术企业”称号，获得中国3A级信用企业证书。建立并通过了“质量、环境、职业健康”管理体系认证，是一家实力较强的测绘企业。<br />
            </p>
            <p class="content">
              公司内设9个部门，拥有专业技术人员40余人，其中包括高级工程师2人，国家注册测绘师2人，工程师5人。配有GNSS、全站仪、六旋翼无人机、四旋翼无人机、五镜头倾斜相机等先进的专业设备仪器，具有扎实的测绘基础理论知识和实战经验。自成立至今，我单位各项工作成绩斐然，先后承接重庆市主城九区、部分区县各工业园区、事业单位等委托勘测、正射影像采集以及土地管理系统研发项目。
            </p>
            <p class="content">
              服务、质量保证承诺：本公司在生产经营中，坚持“用户靠前、信誉至上”的理念，以客户满意为出发点，切实履行合同。确保本公司的质量符合相关法律法规的要求。
            </p>
            <p class="content">
              经营理念、服务宗旨：公司本着“注重服务质量、讲究诚信品质”的经营理念和“规范、高效”的服务宗旨，提倡诚信和谐、
              团结拼搏、担当创新、分享感恩的企业文化，不断深化服务意识，竭诚为广大客户提供优质高能的服务。
            </p>
            <p class="content"></p>
            <p class="content"></p>
            <p class="content"></p>
            <p class="content"></p>
            <p class="content"></p>
            <p class="content"></p>
          </div>
          <div class="summary-right">
            <img src="../assets/img/abut.jpg" alt="" />
            <img src="../assets/img/01.jpg" alt="" />
          </div>
        </div>
        <el-divider class="el-divider-active">
          <i class="el-icon-arrow-down el-icon-arrow-down-active"></i>
        </el-divider>

        <!-- 企业文化 -->
        <div class="content-culture">
          <h3>企业文化</h3>
          <h3>CULTURE</h3>
          <p>诚信、和谐、团结、拼搏、担当、创新、分享、感恩</p>
          <span>诚信、和谐是各位员工的必备的前置条件</span>
          <span>团结、拼搏是各位员工必须付出的努力</span>
          <span>担当、创新是各位员工必须承担的义务</span>
          <span
            >分享、感恩
            最后分享和感恩是相互的，公司愿意同员工一同分享，员工应感恩公司提供平台。</span
          >
        </div>

        <el-divider class="el-divider-active">
          <i class="el-icon-arrow-down el-icon-arrow-down-active"></i>
        </el-divider>
        <!-- 办公环境 -->
        <div class="content-team">
          <div class="top">
            <h3>办公环境</h3>
            <p>Work Environment</p>
            <div class="border"></div>
            <div class="timeline"></div>
          </div>
          <div class="course-time">
            <el-carousel :interval="4000" type="card">
              <el-carousel-item v-for="(team, index) in wokeList" :key="index">
                <div class="swiper-img">
                  <img :src="team.imgurl" alt="" />
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>

        <!-- 荣誉资质 -->
        <div class="content-honor">
          <div class="honor-big-img">
            <el-dialog :title="dialogTitle" :visible.sync="dialogTableVisible">
              <img :src="dialogUrl" alt />
            </el-dialog>
          </div>
          <div class="top">
            <h3>公司荣誉</h3>
            <p>HONOR</p>
            <div class="border"></div>
          </div>
          <ul class="honor-show">
            <li v-for="(honor, index) in honorList" :key="index">
              <img
                :src="honor.imgurl"
                @click="
                  dialogTableVisible = true;
                  dialogUrl = honor.imgurl;
                  dialogTitle = honor.tit;
                "
              />
            </li>
          </ul>
          <p>点击图片查看大图</p>
        </div>

        <!-- 团队风采 -->
        <div class="content-team">
          <div class="top">
            <h3>团队风采</h3>
            <p>TEAM</p>
            <div class="border"></div>
            <div class="timeline"></div>
          </div>
          <div class="team-time">
            <el-carousel :interval="5000" arrow="always">
              <el-carousel-item v-for="(item, idx) in teamItem" :key="idx">
                <div class="swiper-img">
                  <img :src="item.imgurl" alt="" />
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Banner from "../components/Banner";
export default {
  data() {
    return {
      teamItem: [
        {
          imgurl: require("../assets/img/team1.jpg"),
        },
        {
          imgurl: require("../assets/img/team2.jpg"),
        },
        {
          imgurl: require("../assets/img/img01.jpg"),
        },
        {
          imgurl: require("../assets/img/img04.jpg"),
        },
        {
          imgurl: require("../assets/img/img05.jpg"),
        },
      ],
      wokeList: [
        {
          imgurl: require("../assets/img/img03.jpg"),
        },
        {
          imgurl: require("../assets/img/img06.jpg"),
        },
        {
          imgurl: require("../assets/img/img7.jpg"),
        },
        {
          imgurl: require("../assets/img/img8.jpg"),
        },
        {
          imgurl: require("../assets/img/img9.jpg"),
        },
        {
          imgurl: require("../assets/img/img10.jpg"),
        },
      ],
      honorList: [
        {
          tit: "不动产资质证书正本",
          imgurl: require("../assets/img/r1.jpg"),
        },
        {
          tit: "测绘资质证书副本",
          imgurl: require("../assets/img/r2.jpg"),
        },
        {
          tit: "测绘资质证书正本",
          imgurl: require("../assets/img/r3.jpg"),
        },
        {
          tit: "土地规划资质新",
          imgurl: require("../assets/img/r4.jpg"),
        },
        {
          tit: "质量认证证书",
          imgurl: require("../assets/img/r5.jpg"),
        },
        {
          tit: "营业执照",
          imgurl: require("../assets/img/r6.jpg"),
        },
      ],
      dialogTableVisible: false,
      dialogUrl: "",
      dialogTitle: "",
    };
  },
  methods: {},
  components: {
    Banner,
  },
};
</script>
<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.go-in {
  width: 100%;
  height: 100%;
  background-color: #14679f;
  position: relative;
  overflow: hidden;
  .section {
    width: 100%;
    &-content {
      width: 1240px;
      margin: 0 auto;
      background-color: #fff;
      .content-summary {
        display: flex;
        justify-content: space-around;
        padding: 100px 0;
        .summary-left {
          width: 600px;
          .title {
            font-size: 25px;
            color: #e13834;
          }
          .eTitle {
            font-size: 17px;
            color: #e13834;
            padding: 20px 0;
          }
          .content {
            color: #14679f;
            font-size: 16px;
            line-height: 40px;
            text-indent: 25px;
          }
        }

        .summary-right {
          width: 400px;
          height: 700px;
          border: 2px solid #1d42b9;
          border-radius: 10px;
          margin-top: 80px;
          text-align: center;

          img {
            width: 360px;
            height: 270px;
            margin-top: 45px;
            margin-bottom: 20px;
          }
        }
      }

      //企业文化
      .content-culture {
        height: 450px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        padding-left: 100px;
        background-color: #c2daeb;
        h3 {
          color: #3c6088;
          font-size: 26px;
        }
        p {
          color: #3c6088;
          font-size: 26px;
          padding: 5px 0;
        }
        span {
          font-weight: 400;
          line-height: 36px;
          font-size: 18px;
          padding: 5px 0;
        }
      }

      //办公环境
      .content-team {
        padding: 50px 100px;
        .course-time {
          margin-top: 30px;
        }
        .team-time {
          margin-top: 30px;
          width: 100%;

          .swiper-img img {
            width: 100%;
            height: inherit;
          }
        }
        .swiper-img {
          height: 400px;
          background: no-repeat center;
          background-size: cover;
        }
      }

      //荣誉资质

      .content-honor {
        // padding: 50px 0;
        .honor-show {
          width: 90%;
          margin: 30px auto;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          align-content: flex-start;

          li {
            width: 30%;
            height: 320px;
            margin-left: 15px;
            list-style: none;
            border: 1px solid palegoldenrod;
            margin-top: 20px;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        p {
          text-align: center;
          color: #3c6088;
        }
      }
    }
  }
}
@keyframes imgboxkey {
  0% {
    border: solid rgb(29, 66, 185) 2px;
  }
  40% {
    border: solid rgb(255, 255, 255) 2px;
  }
  60% {
    border: solid rgb(255, 255, 255) 2px;
  }
  100% {
    border: solid rgb(29, 66, 185) 2px;
  }
}

@keyframes imgbo {
  0% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
  50% {
    transform: scale(1.1);
    box-shadow: 0px 0px 10px 5px #ababab;
  }
  100% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
}
.el-divider--horizontal {
  margin: 1px 0;
}
.top {
  h3,
  p {
    text-align: center;
    color: #3c6088;
    font-weight: 400;
    padding: 10px 0;
  }
  h3 {
    font-size: 30px;
  }
  p {
    font-size: 20px;
  }
  .border {
    border-bottom: 1px solid #3c6088;
    width: 15%;
    margin: 0 auto;
  }
}
.honor-big-img {
  width: 100%;
  height: 100%;
  z-index: 10;
  text-align: center;
  padding-bottom: 20px;
  //   padding: 5%;
  //background-color: #14679f;
  .el-dialog__wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;

    .el-dialog__body {
      overflow: hidden;
      img {
        width: 100%;
      }
    }
  }
}
</style>